import type { PipelineStage } from '../../store/types.ts';
import { STAGE_LABELS } from '../../store/types.ts';

type StatusBarProps = {
  statusText: string;
  pipelineStage: PipelineStage;
  zoom: number;
  onOpenShortcuts: () => void;
};

export function StatusBar({
  statusText,
  pipelineStage,
  zoom,
  onOpenShortcuts,
}: StatusBarProps) {
  return (
    <div className="ds-statusbar">
      <span className="ds-statusbar__left">
        {statusText || STAGE_LABELS[pipelineStage]}
      </span>
      <div className="ds-statusbar__actions">
        <button type="button" className="ds-statusbar__btn" onClick={onOpenShortcuts} title="Keyboard shortcuts (?)">
          ?
        </button>
        <span className="ds-statusbar__zoom">{Math.round(zoom * 100)}%</span>
      </div>
    </div>
  );
}
